class GA{

	static trackPage(){
		 _gaq.push(['_trackPageview']);
	}

	static trackEvent(category:string, action:string, label:string){
 		_gaq.push(['_trackEvent',category, action,label]);
	}
}